module.exports = __webpack_public_path__ + "img/Central African Republic.beb97e94.svg";